import React, { FC, useEffect } from 'react';
import { SocialBanner } from '@components/molecules/SocialBanner';
import { useGetGallery } from '@services/useGetGallery';

export const GallerySection: FC = () => {
    const { gallery, request: fetchGallery, loading: galleryLoading } = useGetGallery();

    useEffect(() => {
        fetchGallery();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (galleryLoading) {
        return null;
    }

    if (!gallery?.content_gallery_images || gallery.content_gallery_images.length === 0) {
        return null;
    }

    return (
        <SocialBanner
            title={gallery.content_gallery_title}
            subtitle={gallery.content_gallery_description}
            images={gallery.content_gallery_images}
        />
    );
};